import React, { Component } from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import logo from '../Images/mrm-32.png'; 
import './brandbar.css';

export class BrandBar extends Component {
  displayName = BrandBar.name

  settingsClick(e) {
    e.preventDefault();
    window.open("https://www.meetingroommap.net/MapImage");
  }

  render() {
    
    return (
        <footer className="dp-brand-bar ms-borderColor-neutralTertiary ms-bgColor-white">
            <a href="https://www.meetingroommap.net" target="_blank" rel="noopener noreferrer" className="dp-brand-bar--left">
                <img src={logo} alt="logo" />
                <h1 className="ms-font-m ms-fontWeight-semibold ms-fontColor-neutralPrimary">MeetingRoomMap.net</h1>
            </a>
            <div className="dp-brand-bar--right">
                <button id="settingsMenu" className="dp-brand-bar--right__button ms-bgColor-neutralLighter--hover"  onClick={this.settingsClick}>
                    <Icon iconName='Settings' className='ms-fontColor-neutralPrimary' />
                </button>
            </div>
        </footer>
    );
  }
}